import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Spin,
  Col,
  Divider,
} from "antd";
import { useNavigate, Link } from "react-router-dom";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

const NewChequeDeposit = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newSalesTransactionItems, transactionTypeData } = staticConfig;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currencyData, setCurrencyData] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [fromCurrency, setFromCurrency] = useState("");
  const [chargesOptions, setChargesOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ghost, setGhost] = useState(null);
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [savingsAccountDetails, setSavingsAccountDetails] = useState({});
  const Items = [
    {
      key: "1",
      label: "Show Payment Details",
      children: (
        <>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="accountNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.accountNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="checkNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.chequeNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chequeNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="routingCode"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.routingCode}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.routingCode,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="receiptNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.receiptNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.receiptNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="bankNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>{labelConfig.bank}</Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.bank,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  const updateCurrentDate = () => {
    setCurrentDate(new Date());
  };

  useEffect(() => {
    const intervalId = setInterval(updateCurrentDate, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    getCurrencies();
    getLocalCurrencies();
  }, []);

  function getCurrencies() {
    const url = `${apiConfig.GetCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrency = [];

        objList?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });
        // console.log(tempCurrency);
        setCurrencyData(tempCurrency);
      }
    });
  }

  function getLocalCurrencies() {
    const url = `${apiConfig.GetLocalCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrency = [];
      }
    });
  }

  function getByAccountNo(param) {
    const url = `${apiConfig.GetByAccountNo}/${param}`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setSavingsAccountDetails(objList)
        let tempAccountName = objList.clientName;
        let tempAccountCurrency = objList?.currency?.displayLabel;
        let tempToCurrency = objList?.currency?.code;
        let tempSavingsProductId = objList?.savingsProductId;

        // console.log(objList);

        setAccountName(tempAccountName);
        setAccountCurrency(tempAccountCurrency);
        setToCurrency(tempToCurrency);

         // getFxCharges(tempSavingsProductId);
         getTemplate(objList);
        getFxCharges(tempSavingsProductId);
        setIsLoading(false);
      }
    });
  }

  function getTemplate(accParam) {
    const url = `${apiConfig.savingsAccounts}/${accParam.id}/transactions/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentType = [];

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });



        setPaymentTypeData(tempPaymentType);
        setIsLoading(false);
      }
    });
  }

  function getFxCharges(savingsProductId) {
    const url = `${apiConfig.GetFxCharges}/${savingsProductId}/fxcharges`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempChargeOptions = [];

        objList?.forEach((element) => {
          tempChargeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setChargesOptions(tempChargeOptions);
        setIsLoading(false);
      }
    });
  }

  function getConvertedAmount(param) {
    const url = `${apiConfig.convertAmount}/convert?amount=${param}&fromCurrency=${fromCurrency}&rateType=CSH&toCurrency=${toCurrency}&transactionType=1`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempExchangeRate = objList.exchangeRate;
        let tempToAmount = objList.toAmount;

        form.setFieldsValue({
          amount: tempToAmount,
          localCurrencyAmount: tempToAmount,
          exchangeRate: tempExchangeRate,
        });

        setIsLoading(false);
      }
    });
  }

  const handleTransactionCCY = (value) => {
    setFromCurrency(value);
  };

  const onBlurAccountNo = (e) => {
    const value = e.target.value;
    getByAccountNo(value);
  };

  const onBlurAmountTCY = (e) => {
    const value = e.target.value;
    getConvertedAmount(value);
  };

  function onCancel() {
    navigate("/tlo1000", { replace: false });
  }

  const onSubmit = (formValues) => {
    // console.log(formValues);
    // return;

    delete formValues.chequeNo;
    delete formValues.accountCurrencyAmount;
    delete formValues.accountNo;
    delete formValues.exchangeRate;
    delete formValues.localCurrencyAmount;
    delete formValues.transactionCurrencyCode;

    const url = `${apiConfig.savingsAccounts}/${savingsAccountDetails.id}/transactions`;
    const params = {
      command: "deposit",
    };
    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      session,
      params,
    };

    console.log(body)
    setIsLoading(true);
    BOM.FetchReqAction(body,url, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Withdrawal Action was successful");
        navigate("/detail-tlo1000", {
          state: { id: res.resourceId },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  dayjs.extend(customParseFormat);
  const dateFormat = "YYYY-MM-DD";
  const formattedDate = currentDate.toISOString().split("T")[0];
  const date = dayjs(formattedDate, dateFormat);
  const today = BOM.DateTime(date, "only-date");

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newChequeDeposit}
        pageItems={staticConfig.newChequeDepositItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              accountCurrencyAmount: 0,
              localCurrencyAmount: 0,
              exchangeRate: 0,
              transactionDate: today,
              transactionType: "2",
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.depositSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name="transactionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionDate),
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.accountNo),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountNo
                    )}
                    onBlur={onBlurAccountNo}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.chequeNo}
                  name="chequeNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.chequeNo),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.chequeNo)}
                    // onBlur={onBlurchequeNo}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.accountName}>
                  <Input
                    disabled
                    value={accountName}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountName
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionCCY}
                  name="transactionCurrencyCode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionCCY),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.transactionCCY}`,
                      "select"
                    )}
                    options={currencyData}
                    onChange={handleTransactionCCY}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.amountTCY}
                  name="transactionAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.amountTCY),
                    },
                  ]}
                >
                  <Input
                    onBlur={onBlurAmountTCY}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.amountTCY
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.amountACY}
                  name="accountCurrencyAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.amountACY),
                    },
                  ]}
                >
                  <Input
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.amountACY
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentType}
                  name="paymentTypeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.paymentType),
                    },
                  ]}
                >
                  <Select
                    // disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.paymentType}`,
                      "select"
                    )}
                    showSearch
                    options={paymentTypeData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.accountCurrency}>
                  <Input
                    disabled
                    value={accountCurrency}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountCurrency
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.currencyRate}
                  name="exchangeRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.currencyRate),
                    },
                  ]}
                >
                  <Input
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.currencyRate
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.amountLCY}
                  name="localCurrencyAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.amountLCY),
                    },
                  ]}
                >
                  <Input
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.amountLCY
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.charge} name="chargeId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.charge}`,
                      "select"
                    )}
                    options={chargesOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name="note">
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                    style={{ height: "128px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Collapse
                  ghost={ghost}
                  items={Items}
                  bordered={false}
                  expandIconPosition={"end"}
                  style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
                  expandIcon={({ isActive }) => {
                    {
                      isActive ? setGhost(false) : setGhost(true);
                    }
                    return (
                      <>
                        {isActive ? (
                          <MinusOutlined
                            style={{
                              backgroundColor: "#92428B",
                              color: "white",
                              padding: 8,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <PlusOutlined
                            style={{
                              backgroundColor: "#92428B",
                              color: "white",
                              padding: 8,
                              borderRadius: 10,
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewChequeDeposit);
